import * as _ from "lodash";
import * as angular from "angular";
import { VoterFileService } from "../services/voter-file.service";
import { VoterFileImport } from "../models/voter-file-import.model";

export class VoterFile {
    private readonly service: VoterFileService;
    private readonly $q: any;
    private readonly modelsUtils: any;

    public readonly inProgressStatuses = [2, 3, 4, 5, 12, 14];
    public readonly warningStatuses = [9, 15, 16];
    public attributes: any;
    public relationships: any;

    public data?: any;
    public id?: any;
    public erfilename?: any;
    public imports?: VoterFileImport[];

    constructor(
        VoterFileService: VoterFileService,
        $q: any,
        ModelsUtils: any,
        voterFileData?: object
    ) {
        this.service = VoterFileService;
        this.$q = $q;
        this.modelsUtils = ModelsUtils;
        this.setData(voterFileData);
    }

    setData(voterFileData?: object): void {
        if (voterFileData) {
            _.merge(this, voterFileData);
            this.getImports();
        }
    }

    getFileData(): Promise<any> {
        const deferred = this.$q.defer();
        this.service.data({ id: this.attributes.erid }).then(
            (response: object) => {
                const json = response["data"];
                if (json.success && angular.isDefined(json.data)) {
                    this.data = json.data;
                    deferred.resolve();
                } else {
                    deferred.reject();
                }
            },
            (error: any) => deferred.reject(error)
        );
        return deferred.promise;
    }

    getImports(): void {
        this.imports = [];
        if (
            !this.relationships ||
            !this.relationships.data ||
            !this.relationships.data.length
        )
            return;
        for (let i = 0; i < this.relationships.data.length; i++) {
            this.imports.unshift(
                this.modelsUtils.import(this.relationships.data[i])
            );
        }
    }

    inProgress(): boolean {
        if (this.statusid()) {
            return (
                this.inProgressStatuses.indexOf(parseInt(this.statusid())) > -1
            );
        }
        return false;
    }

    hasWarning(): boolean {
        if (this.statusid()) {
            return this.warningStatuses.indexOf(parseInt(this.statusid())) > -1;
        }
        return false;
    }

    status(): string | number | null {
        if (this.attributes) {
            return this.attributes.imsstatus;
        }
        return null;
    }

    statusid(): any {
        if (this.attributes) {
            return this.attributes.imsid;
        }
        return null;
    }

    numFinished(): string | number | null {
        if (this.attributes) {
            return this.attributes.finished;
        }
        return null;
    }

    numTotal(): string | number | null {
        if (this.attributes) {
            return this.attributes.total;
        }
        return null;
    }

    complete(): boolean {
        return this.statusid() == 7;
    }

    readyToImport(): boolean {
        return this.statusid() == 3;
    }

    error(): boolean {
        return (
            this.readError() || this.statusid() == 9 || this.statusid() == 15
        );
    }

    readError(): boolean {
        //8 incompatible for processing only applies to the file not the import.
        if (this.attributes) {
            return this.attributes.imsid == 8;
        }
        return true;
    }

    sizeError(): boolean {
        //16 file is too big or too many columns
        return this.attributes.imsid == 16;
    }
}
